import { render, staticRenderFns } from "./CreatePlace.vue?vue&type=template&id=5a31d7cd&scoped=true&"
import script from "./CreatePlace.vue?vue&type=script&lang=js&"
export * from "./CreatePlace.vue?vue&type=script&lang=js&"
import style0 from "./CreatePlace.vue?vue&type=style&index=0&id=5a31d7cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a31d7cd",
  null
  
)

export default component.exports